import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../components/ui/accordion";

const faqs = [
  { q: "Hoe werkt het persoonlijk trainingsschema?", a: "Na je aanvraag bevestigen wij je betaling en ontvang je een link naar het intakeformulier. Op basis van jouw gegevens stellen we een volledig gepersonaliseerd schema samen — afgestemd op jouw doel, niveau en beschikbaarheid. Je kiest een frequentie van 2 t/m 5x per week (vanaf €30,- per maand). Je ontvangt het schema via e-mail samen met je inloggegevens." },
  { q: "Voor wie zijn de producten van FitSmith geschikt?", a: "Alle producten zijn geschikt voor zowel beginners als gevorderden. Bij het persoonlijk schema stem je via het intakeformulier je doel, niveau en beschikbaarheid af." },
  { q: "Hoe snel ontvang ik mijn persoonlijk schema?", a: "Nadat je intake is ingediend, stellen we je schema doorgaans binnen 2–5 werkdagen samen. Je ontvangt een e-mail zodra het klaar is." },
  { q: "Wat krijg ik als ik de cursus aanschaf?", a: "De FitSmith PT Kickstart Program (€399,95) bevat 20 professionele lessen verdeeld over 4 modules, werkboeken, module-toetsen, een eindtoets én een certificaat na afronding." },
  { q: "Moet ik lid zijn van een sportschool?", a: "Nee, dat is niet verplicht. Bij het intakeformulier geef je aan waar je traint. Je schema wordt hierop afgestemd." },
  { q: "Hoe lang heb ik toegang tot mijn schema of cursus?", a: "Levenslang. Zowel je persoonlijk schema als de cursus zijn altijd terug te vinden in jouw account. Eenmalige betaling — geen abonnementen." },
  {
    q: "Kan ik mijn aankoop terugdraaien?",
    a: "Omdat je direct toegang krijgt tot het digitale product, doe je bij aankoop uitdrukkelijk afstand van je 14 dagen bedenktijd. Na levering is restitutie dan ook niet mogelijk. Uitzondering: bij een aantoonbaar technisch probleem waarbij levering niet gelukt is, bieden wij een passende oplossing.",
    link: { text: "Lees het volledige restitutiebeleid", href: "/restitutiebeleid" },
  },
  { q: "Kan ik contact opnemen als ik vragen heb?", a: "Ja, stuur een e-mail naar info@fitsmith.nl of stuur een bericht via je account. We reageren doorgaans binnen één werkdag." },
];

export default function FAQ() {
  return (
    <section data-testid="faq-section" className="py-20 lg:py-28 bg-[#0d0d0d]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="overline mb-3">Veel gestelde vragen</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">FAQ</h2>
          <p className="text-zinc-400">Alles wat je wilt weten, helder beantwoord</p>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="faq-item">
              <AccordionTrigger className="faq-trigger">{faq.q}</AccordionTrigger>
              <AccordionContent className="faq-content">
                <span>{faq.a}</span>
                {faq.link && (
                  <Link to={faq.link.href}
                    className="block mt-2 text-[#C9A84C] hover:underline text-sm font-semibold">
                    {faq.link.text} →
                  </Link>
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
